import { render } from "./MyProgress.vue?vue&type=template&id=2e4a8ca3&scoped=true"
import script from "./MyProgress.vue?vue&type=script&lang=js"
export * from "./MyProgress.vue?vue&type=script&lang=js"

import "./MyProgress.vue?vue&type=style&index=0&id=2e4a8ca3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4a8ca3"]])

export default __exports__